import replaceAll from './replaceAll';

export default replaceAll('_', '-');
